import classes from "./DisasterAddButton.module.css";
import React, { useContext } from "react";
import { sbHeightCtx } from "../../store/sidebarWiHeContext";

const DisasterAddButton = (props) => {
  const { width } = useContext(sbHeightCtx);
  const sbwith = width * 1.1;
  return (
    <div
      className={classes.button}
      style={{ width: sbwith }}
      onClick={() => props.onOpenModal?.()}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          props.onOpenModal?.();
        }
      }}
    >
      재난 등록
    </div>
  );
};

export default DisasterAddButton;
